import { REVIEW_FLOW_TRIGGER_COUNTERS_STORAGE_KEY } from '../constants';
import type { ReviewFlowTriggerKey } from '../types';

type TriggerCounters = Record<ReviewFlowTriggerKey, number>;

const DEFAULT_COUNTERS: TriggerCounters = {
  download_success: 0,
  editor_edit: 0,
};

const readCounters = (): TriggerCounters => {
  if (typeof window === 'undefined') return DEFAULT_COUNTERS;

  try {
    const raw = window.localStorage.getItem(
      REVIEW_FLOW_TRIGGER_COUNTERS_STORAGE_KEY
    );
    if (!raw) return DEFAULT_COUNTERS;

    const parsed = JSON.parse(raw) as Partial<TriggerCounters> | null;

    return {
      download_success: Number(parsed?.download_success ?? 0) || 0,
      editor_edit: Number(parsed?.editor_edit ?? 0) || 0,
    };
  } catch {
    return DEFAULT_COUNTERS;
  }
};

const writeCounters = (counters: TriggerCounters): void => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(
      REVIEW_FLOW_TRIGGER_COUNTERS_STORAGE_KEY,
      JSON.stringify(counters)
    );
  } catch {}
};

export const readReviewFlowTriggerCounter = (
  trigger: ReviewFlowTriggerKey
): number => readCounters()[trigger];

export const incrementReviewFlowTriggerCounter = (
  trigger: ReviewFlowTriggerKey
): number => {
  const counters = readCounters();
  const nextCount = (counters[trigger] ?? 0) + 1;

  writeCounters({ ...counters, [trigger]: nextCount });

  return nextCount;
};
